import React from "react";
import { Button, Icon } from "@nike/epic-react-ui";
import "./component.css";
import "./PalletGroup/palletGroupAssignment.css";

function Header({ handleLogout, displayLogout, dcLabel }) {
  return (
    <header className="pg-app-header">
      <span className="pg-app-header__brand">{dcLabel || "DECON"}</span>
      <div className="pg-app-header__center">
        <Icon size="l" type="NikeApp" className="pg-app-header__swoosh" aria-hidden />
        <span className="pg-app-header__title">INBOUND PLANNING</span>
      </div>
      <div className="pg-app-header__logout">
        {displayLogout && (
          <Button extraSmall onClick={handleLogout}>
            Log Out
          </Button>
        )}
      </div>
    </header>
  );
}

export default Header;
